import { getAuthHeader, getUserInfo } from '../utils/tokenManager';

const API_BASE_URL = 'https://trpliveapi1.tripbox.co.kr';

// Function to handle API errors
const handleApiError = (error) => {
  console.error('API Error:', error);
  throw error;
};

// Get tour product resource list (투어상품자원리스트)
// SP: DBO.RCT_S_%ED%88%AC%EC%96%B4%EC%83%81%ED%92%88%EC%9E%90%EC%9B%90%EB%A6%AC%EC%8A%A4%ED%8A%B8
// payload Table1: @업체번호, @상품번호
export const getTourProductResourceList = async ({ companyNo, productNo }) => {
  try {
    const payload = {
      Table1: [
        { 컬럼명: '@업체번호', 값: String(companyNo), 리스트값: null },
        { 컬럼명: '@상품번호', 값: Number(productNo), 리스트값: null },
      ],
    };
    const url = `${API_BASE_URL}/ERP/GetDataSet?procedureName=DBO.RCT_S_%ED%88%AC%EC%96%B4%EC%83%81%ED%92%88%EC%9E%90%EC%9B%90%EB%A6%AC%EC%8A%A4%ED%8A%B8`;
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
      body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error(`API error: ${response.status}`);
    const data = await response.json();
    // Return normalized table data
    const candidates = [data?.table, data?.table1, data?.Table, data?.Table1, data?.Table0];
    for (const c of candidates) {
      if (Array.isArray(c) && c.length) return c;
    }
    return Array.isArray(data?.table) ? data.table : [];
  } catch (error) {
    return handleApiError(error);
  }
};

// Enhanced function to get comprehensive price data for quote saving
// This function combines resource list and rate plan data to build complete payload
export const getEnhancedPriceDataForQuote = async ({ productNo, companyNo, priceNo }) => {
  try {
// 1. 상품자원리스트 조회
    const resourceList = await getTourProductResourceList({ companyNo, productNo });
// 2. 각 자원에 대한 요금제리스트 조회 (기존 getTourRatePlanList02 함수 사용)
    const { getTourRatePlanList02 } = await import('./apiService');
    
    const 상품자원요금제 = [];
    const 요금제Map = new Map();
    
    // 자원리스트가 비어있으면 기본 자원 추가
    if (!resourceList || resourceList.length === 0) {
상품자원요금제.push({
        자원번호: 99820,
        자원명: '기초상품자원',
        요금제리스트: [{
          가격옵션번호: Number(priceNo || 193056),
          가격옵션명: '기본요금제',
          합산가격여부: 'N'
        }]
      });
      
      if (priceNo) {
        요금제Map.set(Number(priceNo), {
          요금제번호: Number(priceNo),
          요금제명: '기본요금제'
        });
      }
    } else {
      for (const resource of resourceList) {
        const resourceNo = resource.자원번호 || resource.resourceNo || resource.번호;
        const resourceName = resource.자원명 || resource.resourceName || resource.이름;
        
        if (!resourceNo) continue;
        
        try {
          const ratePlans = await getTourRatePlanList02({ companyNo, productNo, resourceNo });
const 요금제리스트 = ratePlans.map(plan => {
            const planNo = plan.가격옵션번호 || plan.planNo || plan.번호;
            const planName = plan.가격옵션명 || plan.planName || plan.이름 || '기본요금제';
            
            // 요금제 정보 수집
            if (planNo) {
              요금제Map.set(Number(planNo), {
                요금제번호: Number(planNo),
                요금제명: planName
              });
            }
            
            return {
              가격옵션번호: Number(planNo || priceNo || 0),
              가격옵션명: planName,
              합산가격여부: 'N'
            };
          });
          
          상품자원요금제.push({
            자원번호: Number(resourceNo),
            자원명: resourceName,
            요금제리스트
          });
          
        } catch (err) {
          console.warn(`[가격데이터 보강] 자원 ${resourceNo} 요금제 조회 실패:`, err);
          // 실패해도 기본 요금제로 추가
          상품자원요금제.push({
            자원번호: Number(resourceNo),
            자원명: resourceName,
            요금제리스트: [{
              가격옵션번호: Number(priceNo || 0),
              가격옵션명: '기본요금제',
              합산가격여부: 'N'
            }]
          });
          
          if (priceNo) {
            요금제Map.set(Number(priceNo), {
              요금제번호: Number(priceNo),
              요금제명: '기본요금제'
            });
          }
        }
      }
    }
    
    // 3. 선택요금제 및 요금제 배열 생성
    const 선택요금제 = priceNo ? [{ 가격옵션번호: Number(priceNo), 합산가격여부: 'N' }] : [];
    const 요금제 = Array.from(요금제Map.values());
    
    // 요금제가 비어있으면 기본 요금제 추가
    if (요금제.length === 0 && priceNo) {
      요금제.push({
        요금제번호: Number(priceNo),
        요금제명: '기본요금제'
      });
    }
    return {
      상품자원요금제,
      선택요금제,
      요금제
    };
    
  } catch (error) {
    console.error('[가격데이터 보강] 실패:', error);
    // 실패 시 기본값 반환 (정상 페이로드와 동일한 구조)
    return {
      상품자원요금제: [{
        자원번호: 99820,
        자원명: '기초상품자원',
        요금제리스트: [{
          가격옵션번호: Number(priceNo || 193056),
          가격옵션명: '기본요금제',
          합산가격여부: 'N'
        }]
      }],
      선택요금제: priceNo ? [{ 가격옵션번호: Number(priceNo), 합산가격여부: 'N' }] : [],
      요금제: [{
        요금제번호: Number(priceNo || 193056),
        요금제명: '기본요금제'
      }]
    };
  }
};
